
// Read-only lines of a pending warehouse order, pushed from the "From warehouse orders" picker so the
// user can see what each order asks for before selecting it.
class BuyOrderWarehouseOrderLinesViewController extends MUIViewController
{
    static newInstance() : BuyOrderWarehouseOrderLinesViewController {
        let vc = new BuyOrderWarehouseOrderLinesViewController("buy-order-warehouse-order-lines-view");
        vc.initWithResource("layout/stock_buy_orders/BuyOrderWarehouseOrderLinesView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(700, 520);
    }

    private backButton:MUIButton = null;
    private titleLabel:MUILabel = null;
    private subtitleLabel:MUILabel = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function(this:BuyOrderWarehouseOrderLinesViewController){
            if (this.navigationController != null) this.navigationController.popViewController(true);
            else this.dismissViewController(true);
        });

        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.subtitleLabel = MUIOutlet(this, "subtitle-lbl", "MUILabel");

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
    }

    viewWillAppear(animated?:boolean){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _order:WarehouseOrder = null;
    set order(order:WarehouseOrder){
        this._order = order;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._order == null) return;

        this.titleLabel.text = this._order.documentID;
        this.subtitleLabel.text = (this._order.originName ?? "") + " → " + (this._order.destinationName ?? "");

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.fetchedResultsController.sections[section].numberOfObjects();
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("LineCell") as BuyOrderWarehouseOrderLineCell;
        cell.item = this.fetchedResultsController.objectAtIndexPath(indexPath) as WarehouseOrderLine;
        return cell;
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null) this._fetchedResultsController.delegate = null;
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("orderIndex", true)];
        let predicateFormat = "note.identifier == " + this._order.identifier;

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("WarehouseOrderLine", sortDescriptors, predicateFormat);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
    }
}
